import { FaChevronRight, FaChevronDown, FaUsers } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import NavbarDropdown from "./NavDropDown";
import { AiFillHome } from "react-icons/ai";
import { useSelector } from "react-redux";
import { BsCardChecklist } from "react-icons/bs";
import "./leftnavbar.scss";
import {
  Article,
  PostAddOutlined,
  PendingActionsOutlined,
  AssignmentTurnedInOutlined,
  SwapHorizOutlined,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import { Box, Tooltip } from "@mui/material";

// New client sidebar (default) that routes to the new-* pages
function NewClientLeftNav({ onClose, onSwitchVersion }) {
  const isOpen = useSelector((state) => !state.sidebar.isOpen);

  const menuItems = [
    {
      to: "/new-client-dashboard",
      icon: <AiFillHome className="nav_icon" />,
      label: "Dashboard",
    },
    {
      to: "/new-my-team",
      icon: <FaUsers className="nav_icon" />,
      label: "My Team",
    },
    {
      to: "/new-client-ordered-report",
      icon: <Article className="nav_icon" />,
      label: "BPO Report",
    },
    {
      icon: <BsCardChecklist className="nav_icon" />,
      label: "Deal Analyzer",
      isCollapsible: true,
      subItems: [
        {
          to: "/analyze-deal",
          label: "Analyze any Property of Your Choice",
          icon: <PostAddOutlined className="nav_icon" />,
        },
        {
          to: "/dealanalyzer-reports/uncompleted-reports",
          label: "Uncompleted Reports",
          icon: <PendingActionsOutlined className="nav_icon" />,
        },
        {
          to: "/dealanalyzer-reports/completed-reports",
          label: "Completed Reports",
          icon: <AssignmentTurnedInOutlined className="nav_icon" />,
        },
      ],
    },
  ];

  return (
    <div
      className="left_navbar left_navbar--new"
      style={{
        width: isOpen ? "22.7%" : "80px",
        paddingTop: "1rem",
      }}
    >
      <div className="nav_links_wrapper">
        {menuItems.map((item) => (
          <Box key={item.label}>
            {item.isCollapsible ? (
              <NavbarDropdown
                label={({ show }) => (
                  <div
                    className="nav_link"
                    style={{
                      padding: isOpen
                        ? "12px 20px 12px 24px;"
                        : "12px 0px 12px 16px",
                    }}
                  >
                    <Tooltip title={isOpen ? "" : item.label} placement="right">
                      <Box>{item.icon}</Box>
                    </Tooltip>
                    {isOpen && (
                      <>
                        <p>{item.label}</p>
                        {show ? (
                          <FaChevronDown className="drop_icon" />
                        ) : (
                          <FaChevronRight className="drop_icon" />
                        )}
                      </>
                    )}
                  </div>
                )}
                routesToCheck={[
                  "analyze-deal",
                  "dealanalyzer-reports/uncompleted-reports",
                  "dealanalyzer-reports/completed-reports",
                ]}
              >
                <Box
                  py={1}
                  // sx={{ bgcolor: isOpen ? "paper.main" : "background.default" }}
                >
                  {item.subItems.map((subItem) => (
                    <NavLink
                      key={subItem.to}
                      className="nav_link"
                      to={subItem.to}
                      onClick={onClose}
                      style={{
                        padding: isOpen
                          ? "12px 20px 12px 24px;"
                          : "12px 0px 12px 16px",
                      }}
                    >
                      {isOpen ? (
                        <p>{subItem.label}</p>
                      ) : (
                        <Tooltip
                          title={isOpen ? "" : subItem.label}
                          placement="right"
                        >
                          <Box>{subItem.icon}</Box>
                        </Tooltip>
                      )}
                    </NavLink>
                  ))}
                </Box>
              </NavbarDropdown>
            ) : (
              <NavLink
                className="nav_link"
                to={item.to}
                onClick={onClose}
                style={{
                  padding: isOpen
                    ? "12px 20px 12px 24px;"
                    : "12px 0px 12px 16px",
                }}
              >
                <Tooltip title={isOpen ? "" : item.label} placement="right">
                  <Box>{item.icon}</Box>
                </Tooltip>
                {isOpen && <p>{item.label}</p>}
              </NavLink>
            )}
          </Box>
        ))}

        {/* Switcher to the old sidebar */}
        {onSwitchVersion && (
          <>
            {isOpen ? (
              <button
                type="button"
                className="nav_link"
                onClick={() => {
                  onSwitchVersion();
                  onClose?.();
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  textAlign: "left",
                }}
              >
                <p>Use old dashboard</p>
              </button>
            ) : (
              <NavLink
                className="nav_link"
                onClick={() => {
                  onSwitchVersion();
                  onClose?.();
                }}
                style={{
                  padding: isOpen
                    ? "12px 20px 12px 24px;"
                    : "12px 0px 12px 16px",
                }}
              >
                <Tooltip
                  title={isOpen ? "" : "Use old dashboard"}
                  placement="right"
                >
                  <Box>
                    <SwapHorizOutlined className="nav_icon" />
                  </Box>
                </Tooltip>
              </NavLink>
            )}
          </>
        )}
      </div>
    </div>
  );
}

NewClientLeftNav.propTypes = {
  onClose: PropTypes.func,
  onSwitchVersion: PropTypes.func,
};

export default NewClientLeftNav;
